<template>
  <div>
    <!-- 顶部 -->
    <div class="header">
      <div class="h_con content">
        <h1 class="logo">
          <a href="/" title="济南恒智自控技术有限公司"><img src="../../images/logo.png" alt="济南恒智自控技术有限公司" ></a>
        </h1>
        <div class="line"></div>
        <h2 class="slogan">
          <strong>集研发、制造、工程、销售、技术服务于一体 </strong><span>合理定制规划 开发周期短 故障率更低</span>
        </h2>
        <img class="img" src="../../images/tel.png">
        <div class="h_contact">
          <span>服务热线：</span><em>0531-55511916</em>
        </div>
      </div>
    </div>
    <!-- 菜单 -->
    <div class="menu h_nav">
      <div class="content clearfix">
        <ul>
          <li v-bind:class="path == '/home' ? 'menu_ch' : ''"><router-link :to="{ path: '/', query: { name: '首页' } }"
              title="首页">首页</router-link></li>
          <li v-for="( item, index ) in  cptypeList " :key="index"
            v-bind:class="path == '/HzControl?id=' + item.id || superior == item.id ? 'menu_ch' : ''">
            <router-link :to="{ path: '/HzControl', query: { id: item.id, name: item.name } }" :title="item.name">{{
              item.name
            }}</router-link>
            <p v-show="item.name == '系统控制柜'">
              <router-link v-for="( it, index ) in item.children" :key="index"
                :to="{ path: '/HzControl', query: { superior: it.superior,id: it.id, name: it.name } }" :title="it.name">{{ it.name
                }}</router-link>
            </p>
          </li>
          <!-- <li><router-link :to="{ path: '/HzControl', query: { name: '系统控制柜' } }">系统控制柜</router-link></li> -->
          <li v-bind:class="path == '/HzProduct' || cptitle == '产品中心' ? 'menu_ch' : ''"><router-link
              :to="{ path: '/HzProduct', query: { name: '产品中心' } }" title="产品中心">产品中心</router-link>
            <p>
              <router-link v-for="( item, index ) in products" :key="index"
                :to="{ path: '/HzProduct', query: { cptype: '品牌',id: item.id, name: item.name } }" :title="item.name">{{ item.name
                }}</router-link>
            </p>
          </li>
          <li v-bind:class="path == '/HzHyal' || altitle == '行业案例' ? 'menu_ch' : ''"><router-link
              :to="{ path: '/HzHyal', query: { name: '行业案例' } }" title="行业案例">行业案例</router-link>
          </li>
          <li v-bind:class="path == '/HzUs' ? 'menu_ch' : ''"><router-link
              :to="{ path: '/HzUs', query: { name: '关于恒智' } }" title="关于恒智">关于恒智</router-link>
          </li>
          <li v-bind:class="path == '/HzContact' ? 'menu_ch' : ''"><router-link
              :to="{ path: '/HzContact', query: { name: '联系我们' } }" title="联系我们">联系我们</router-link></li>
          <li>
            <el-link href="http://hengzhiyun.net/" target="_blank" title="恒智云">恒智云</el-link>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <router-view class="rou" />
    </div>
    <!-- 底部 -->

    <div class="footer">
      <div class="f_con content">
        <div class="f_nav">
          <h3>网站导航</h3>
          <a href="/" title="首页">首页</a>
          <!-- <a > -->
          <router-link v-for="( item, index ) in  cptypeList " :key="index"
            :to="{ path: '/HzControl', query: { id: item.id, name: item.name } }" :title="item.name">{{ item.name
            }}</router-link>
          <router-link :to="{ path: '/HzHyal', query: { name: '行业案例' } }" title="行业案例">行业案例</router-link>
          <router-link :to="{ path: '/HzUs', query: { name: '关于恒智' } }" title="关于恒智">关于恒智</router-link>
          <router-link :to="{ path: '/HzContact', query: { name: '联系我们' } }" title="行业案例">联系我们</router-link>
        </div>
        <div class="f_contact">
          <h3>联系方式</h3>
          <p>公司地址：济南市历城区华龙路1825号嘉恒商务大厦B座803室</p>
          <p>生产地址：济南市历城区虞山路5567号大博科技园13号楼402</p>
          <p>电话：0531-55511916</p>
          <p>邮箱：hzzk@hengzhizikong.com</p>
        </div>
        <div class="f_qr">
          <h3>扫一扫二维码</h3>
          <i><img src="../../images/wxgzh.jpg" alt="扫一扫关注微信"><span>扫一扫<br />关注微信</span></i>
          <i><img src="../../images/sjz.jpg" alt="扫描进入手机站"><span>扫描进入<br />手机站</span></i>
        </div>
      </div>
      <div class="f_info">
        <div class="content">
          <p>济南恒智自控技术有限公司 Copyright © 版权所有<span><a href="https://beian.miit.gov.cn/#/Integrated/index"
                title="鲁ICP备15017770号-2" target="_blank" rel="nofollow">鲁ICP备15017770号-2</a></span></p>
        </div>
      </div>
    </div>

    <!--在线客服-->
    <div class="kef">
      <dl class="toolbar" id="toolbar">
        <dd><a class="slide tel slide-tel" href="javascript:;" title="咨询热线"><i><span></span></i>0531-55511916</a></dd>
        <dd><a href="javascript:;" title="QQ咨询"><i class="qq"><span></span></i></a></dd>
        <dd><i class="code"><span></span></i>
          <ul class="pop pop-code">
            <li>
              <img src="../../images/wxgzh.jpg" alt="微信公众号" />
              <!-- <span>微信公众号</span> -->
            </li>
          </ul>
        </dd>
        <dd> <a href="javascript:void(0);" title="返回顶部"><i id="top" class="top" @click="toTop(step)"><span></span></i></a>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import http from '../../js/axios'
import router from '../../router'

export default {
  name: 'Analysis',
  components: {
    router
  },
  props: {
    step: { //此数据是控制动画快慢的
      type: Number,
      default: 150
    }
  },
  data() {
    return {
      name: this.$route.query.name,
      altitle: this.$route.query.title,
      superior: this.$route.query.superior,
      cptitle: this.$route.query.cptitle,
      menuT: '',
      image: '',
      titles: '',
      animate: false,
      showNum: 9, // 可见列表条数
      cptypeList: [],
      menus: [],
      sysCon: [],
      products: [],
    }
  },
  computed: {
    text() {
      return {
        id: this.number,
        val: this.arr[this.number]
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.path = this.$route.fullPath
        if (this.path.split('?')[0] === '/HzControl') {
          this.path = this.path.split('&')[0]
        } else if (this.path.indexOf('?') != -1) {
          this.path = this.path.split('?')[0]
        }
        // console.log(this.path);
      }
    }
  },
  created() {
    this.image = http.imageURL
    this.path = this.$route.fullPath
    if (this.path.split('?')[0] === '/HzControl') {
      this.path = this.path.split('&')[0]
    } else if (this.path.indexOf('?') != -1) {
      this.path = this.path.split('?')[0]
    }
    // console.log(this.path);
    this.titles = window.localStorage.getItem('titles')
    this.queryCpMenu();
  },
  mounted() {

  },
  methods: {
    queryCpMenu() {
      //系統控制柜
      http.get('/hzCpTree/cpTree', { params: { menuT: 'K' } }).then((res) => {
        let kzgtypes = res.data.data.result;
        window.localStorage.setItem('kzgType', JSON.stringify(kzgtypes));
        // console.log(kzgtypes);
      })
      http.get('/hzCpTree/cpTree', { params: { menuT: 'D' } }).then((res) => {
        res.data.data.result.forEach(item => {
          if (item.name !== '产品中心') {
            this.cptypeList.push(item)
          } else {
            this.products = item.children;
          }
        })
        this.cptypeList.forEach(e => {
          if (e.name === '系统控制柜') {
            this.menus = e.children;
            e.children.forEach(son => {
              this.sysCon.push(son.name);
            })
          }
        })
      })
    },
    toTop(i) {
      //参数i表示间隔的幅度大小，以此来控制速度
      document.documentElement.scrollTop -= i;
      if (document.documentElement.scrollTop > 0) {
        var c = setTimeout(() => this.toTop(i), 16);
      } else {
        clearTimeout(c);
      }
    },
  }
}
</script>

<style>
@import "../../config/common.css"


/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 15px; */
</style>



// WEBPACK FOOTER //
// src/views/dashboard/Analysis.vue